import { toast } from "./toast";

// Prints one element in a window of its own, with the app's styles, so the page around it is left out
export const printElement = (node, title) => {
  const win = window.open("", "_blank");
  if (!win) {
    console.warn("Print window blocked by the browser");
    toast.error("Allow pop-ups for this site to print.");
    return;
  }
  const styles = [...document.querySelectorAll('link[rel="stylesheet"], style')].map((n) => n.outerHTML).join("");
  win.document.write(`<!doctype html><html><head><meta charset="utf-8">${styles}</head><body class="bg-white p-8">${node.outerHTML}</body></html>`);
  win.document.title = title;
  win.document.close();
  win.addEventListener("load", () => {
    win.focus();
    win.print();
  });
};
